module.exports = __webpack_public_path__ + "static/media/file-upload.ee2f38c2.svg";